import { render, staticRenderFns } from "./ModifyNoRealTaskDialog2.vue?vue&type=template&id=30c1c418&"
import script from "./ModifyNoRealTaskDialog2.vue?vue&type=script&lang=js&"
export * from "./ModifyNoRealTaskDialog2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports